module.exports = __webpack_public_path__ + "img/search.430c6fb3.jpg";